import { useEffect } from "react"
import { __ } from "src/libs/utilities"
import { useUser } from "src/settings/zustand/user"
import { actions } from "../../data/actions"
import { UPDATE_TEST_USER_RESULT_ACTION } from "../../data/actionTypes"
import { FINISH_VIEW_TYPE, IPETest, PE_TEST_AUTH_TYPE } from "../../data/interfaces"
import { ITestsStore, useTestsStore } from "../../data/store"
import Results from "./Results"
import { ITestProps } from "./SingleTest"
import FinishResultMessage from "./FinishResultMessage"
import ExternalFinish from "./ExternalFinish"
import Shortcode from "src/libs/useful/shortcode"

 
const Finish = ( {item, ...props} : ITestProps) : JSX.Element => {
    const user = useUser()
    const currentTest: IPETest  = useTestsStore((state: ITestsStore) => state.currentTest )
    const results: any[]        = useTestsStore((state: ITestsStore) => state.results ) 
    useEffect(() => {
        if(currentTest.auth_type !== PE_TEST_AUTH_TYPE.ANONYM){
            actions(
                UPDATE_TEST_USER_RESULT_ACTION, 
                {
                    user_id: user.id,
                    test_id: currentTest.id,
                    results : JSON.stringify(results),
                    user_data: JSON.stringify("") 
                }
            )
        }
        else {
            useTestsStore.setState({
                lastResults : [
                    ...( useTestsStore.getState().lastResults || [] ).filter((lr: any) => {
                        return !( lr.testId === currentTest.id && lr.user.id === user.id )
                    }),
                    {
                        user,
                        testId: currentTest.id,
                        results
                    }
                ]
            })
        }
    }, [])
    return <div className="pe-matchings-finish mt-5 pt-5 " data-testid="test-finish">
         <div className=" container flex-centered flex-column">
            <Shortcode 
                content={ item.finish_message || ""  } 
                className={"my-4" } 
            />
            <div className="pe-matching-results">
                <ShowFinish item={item} { ...props } />
            </div>
            <div>
                <ExternalFinish item={item} results={results}/>
            </div>
        </div>
    </div>
} 

export default Finish

const ShowFinish = ({item, ...props}: any) : JSX.Element => {
    switch( item.finish_view_type ) {
        case FINISH_VIEW_TYPE.MESSAGE:
            return <FinishResultMessage item={item} { ...props } />
        case FINISH_VIEW_TYPE.SHOW_RESULT:
        default:
            return <Results item={item} { ...props } />
    }
}